module.exports = __webpack_public_path__ + "static/media/psn.1a0d57a6.svg";